import * as React from "react";
import { observer } from "mobx-react";

import { ErrorDisplay } from "Components/General/Error";
import { CanvasLoader, Loader } from "Components/General/Loader";
import { DataStore } from "Stores/RESTStore/DataStore";
import { CoreStore } from "Stores/RESTStore/CoreStore";
import { ListStore } from "Stores/RESTStore/ListStore";

interface DisplayFetchError {
  store: ListStore<Object> | DataStore<Object> | CoreStore;
  experimentalLoader?: boolean;
}
interface DefaultAPIErrorProps extends DisplayFetchError {
  state?: string;
  children?: React.ReactNode;
}

export const DisplayAPIError = observer(
  class DisplayAPIError extends React.Component<DefaultAPIErrorProps> {
    render() {
      const { store, state = "state", experimentalLoader } = this.props;
      const displayOptions = {
        ERROR: () => <ErrorDisplay err={store[`${state}Error`]} />,
        DONE: () => <div style={{ width: "100%" }}>{this.props.children}</div>,
        LOADING: () => (experimentalLoader ? <CanvasLoader /> : <Loader />),
      };

      return (displayOptions[store[state]] || displayOptions.LOADING)();
    }
  }
);
